<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
  >
    <g clip-path="url(#clip0_3607_92)">
      <path
        d="M9.69946 12.7976H3.12051V6.13095H7.34984V5.17857H3.12051C2.6036 5.17857 2.18066 5.60714 2.18066 6.13095V12.7976C2.18066 13.3214 2.6036 13.75 3.12051 13.75H9.69946C10.2164 13.75 10.6393 13.3214 10.6393 12.7976V8.5119H9.69946V12.7976ZM6.03875 11.2881L5.11769 10.1643L3.8254 11.8452H8.99457L7.33104 9.60238L6.03875 11.2881ZM10.6393 5.17857V3.75H9.69946V5.17857H8.28969C8.29439 5.18333 8.28969 6.13095 8.28969 6.13095H9.69946V7.55476C9.70416 7.55952 10.6393 7.55476 10.6393 7.55476V6.13095H12.0491V5.17857H10.6393Z"
        :fill="color"
      />
    </g>
    <defs>
      <clipPath id="clip0_3607_92">
        <rect
          width="14.8026"
          height="15"
          fill="white"
          transform="translate(0.947266)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  name: 'AddPhotoIcon',
  props: {
    color: {
      type: String,
      default: '#B9B9C3',
    },
  },
}
</script>
